import * as React                           from 'react';

import { SpecificationHelpEx1Vector       } from 'src/components/vector/art/specification-help-ex1';

import { Dialog                           } from 'src/components/common/dialog';
import { IconButton                       } from 'src/components/common/icon-button';

import { Container,
         Caption,
         Message,
         Close,
         CloseOutlineVectorBig,
         SpecificationHelpDialogVariants,
         specificationhelpdialog_variants } from 'src/components/features/inspection/edit/specification-help-dialog/ui';



type Props = {
  variant: SpecificationHelpDialogVariants;
  opened: boolean;
  onClose: () => void;
}
export const SpecificationHelpDialog: React.FC<Props> = ({
  variant,
  opened,
  onClose,
}) => {
  const lookAndFeel = specificationhelpdialog_variants.get(variant)!;

  return (
    <Dialog variant = { lookAndFeel.dialogVariant } isOpened = { opened }>
      <Container lookAndFeel = { lookAndFeel }>
        <Close lookAndFeel = { lookAndFeel }>
          <IconButton
            variant = { lookAndFeel.closeButtonVariant }
            isTapAllowed
            onTap = { onClose }
          >
            <CloseOutlineVectorBig />
          </IconButton>
        </Close>
        <Caption lookAndFeel = { lookAndFeel }>
          Подсказка
        </Caption>
        <Message lookAndFeel = { lookAndFeel }>
          Для корректного создания осмотра необходимо сосканировать/ ввести номер спецификации и номер позиции по спецификации или выбрать все позиции
        </Message>
        <SpecificationHelpEx1Vector />
       </Container>
    </Dialog>
  );
};
